import {
  FinanceType,
  FeeCategory,
  FixedValueFee,
} from '@upstart/harmony/lib/constants';
import { cloneDeep } from 'lodash';
import { FeeTable, FeeRow } from '../components/DealerLaunchDashboard/types';
import { DealerFees } from '../types/dealerTypes';

/**
 * Converts the fee table format to one that's compatible with dealer.fees
 */
export const convertFeeTableToDealerFees = (table: FeeTable): DealerFees => {
  const fees: DealerFees = {
    New: {},
  };

  (Object.entries(table) as [FinanceType, FeeRow[]][]).forEach(
    ([financeType, rows]) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      fees.New![financeType] = {
        taxable: [],
        nontaxable: [],
      };
      if (financeType === FinanceType.LEASE) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        fees.New![financeType]!.capitalizedCost = [];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        fees.New![financeType]!.capitalizedCostTaxable = [];
      }

      rows.forEach((row) => {
        let category;
        if (row.taxable) {
          if (row.capCost) {
            category = FeeCategory.CAPITALIZED_COST_TAXABLE;
          } else {
            category = FeeCategory.TAXABLE;
          }
        } else if (row.capCost) {
          category = FeeCategory.CAPITALIZED_COST;
        } else {
          category = FeeCategory.NON_TAXABLE;
        }

        fees.New?.[financeType]?.[category]?.push({
          type: FixedValueFee,
          name: row.name,
          value: row.value,
          includeInFeeStack: row.includeInFeeStack,
        });
      });
    },
  );

  // copy over the fees from new to used
  fees.Used = cloneDeep(fees.New);
  // lease fees aren't appicable for used
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  delete fees.Used!.lease;

  return fees;
};
